import { render } from "./SSOInputA4.vue?vue&type=template&id=5746af81"
import script from "./SSOInputA4.vue?vue&type=script&lang=js"
export * from "./SSOInputA4.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__